/**
 * Feature flags configuration for the application.
 * These flags are loaded from environment-specific config files in src/config/
 * 
 * Configuration files:
 * - src/config/staging.json - Staging environment settings
 * - src/config/production.json - Production environment settings
 */

import stagingConfig from '../config/staging.json';
import productionConfig from '../config/production.json';

// Type definition for config structure
interface Config {
  featureFlags: {
    showAuthRoutes: boolean;
    showDeleteAccountButton: boolean;
  };
}

// Select config based on environment
const env = process.env.REACT_APP_ENV || 'staging';
const config: Config = env === 'production' ? productionConfig : stagingConfig;

/**
 * Feature flags loaded from environment-specific configuration.
 * 
 * showAuthRoutes: Controls whether authentication routes (login/signup) are accessible.
 *   - When false, login and signup attempts redirect to waitlist
 *   - When true, login and signup pages work normally
 * 
 * showDeleteAccountButton: Controls whether delete account button is visible.
 *   - Useful for development/staging to keep database clean during testing
 *   - Should be false in production
 */
export const featureFlags = config.featureFlags;

/**
 * Helper function to check if a specific feature is enabled.
 * @param flag - The feature flag to check
 * @returns boolean indicating if the feature is enabled
 */
export const isFeatureEnabled = (flag: keyof typeof featureFlags): boolean => {
  return featureFlags[flag];
};
